







































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { isMobileApp } from "@/shared/mobileHelper";

@Component
export default class DrivewealthDisclosures extends Vue {
  get isMobile () {
    return isMobileApp();
  }
}
